// YoutubeSlider.jsx
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const videoIds = [
  "Ls4A4l-r6rA",
  "jTkE4qLu0YY",
  "s9jwbzqYe94",
  "D3c1tcVwBns",
  "Gn8HvDLnhLU",
  "obV_BWHvQiM"
];

export default function YoutubeSlider() {
  return (
    <div style={{ padding: "0 30px" }}> 
      {/* adds left-right space */}
      <Swiper
        modules={[Navigation]}
        navigation
        spaceBetween={30}  // more space between videos
        slidesPerView={1}
        slidesPerGroup={1}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
        }}
        style={{ paddingBottom: "40px" }}
      >
        {videoIds.map((id) => (
          <SwiperSlide key={id}>
            <iframe
              width="100%"
              height="220"
              src={`https://www.youtube.com/embed/${id}`}
              title="YouTube video"
              frameBorder="0"
              allowFullScreen
              style={{ borderRadius: "10px" }}
            ></iframe>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
